<div class="timer timer__{{ percents }}" *ngIf="percents || percents === 0">
  <div class="timer__point"></div>
  <div class="timer__number">
    <span>{{ formattedTime }}</span>
  </div>
</div>
  